module.exports = __webpack_public_path__ + "img/ip-header-start.919859e3.svg";